export default "__VITE_ASSET__CuM3Vsef__"